/**
 * /operations/ta-agent — Tashghil drives T&A operations;
 * Mutaba'aa enforces Article 99/104/105/107 continuously.
 */

import { PageHeader } from "../components/ui";
import { AgentBadge } from "../components/ui/AgentBadge";

export function TimeAttendanceAgentPage() {
  return (
    <div className="space-y-6">
      <PageHeader
        title="Time & Attendance Agent"
        subtitle="Tashghil routes T&A workflows; Mutaba'aa enforces Articles 99 / 104 / 105 / 107 in real time."
      />

      <section className="bg-surface-default border border-border-default rounded-lg p-4">
        <div className="flex items-center gap-2 mb-3">
          <AgentBadge agent="tashghil" />
          <h3 className="text-base font-semibold">Tashghil — daily ops</h3>
        </div>
        <ul className="text-sm text-text-secondary space-y-1.5">
          <li>Auto-approve excuses within scope per autonomy mode.</li>
          <li>Route late-arrival workflows.</li>
          <li>Flag attendance anomalies to HR queue.</li>
        </ul>
      </section>

      <section className="bg-surface-default border border-border-default rounded-lg p-4">
        <div className="flex items-center gap-2 mb-3">
          <AgentBadge agent="mutabaa" />
          <h3 className="text-base font-semibold">
            Mutaba'aa — statutory enforcement
          </h3>
        </div>
        <ul className="text-sm text-text-secondary space-y-1.5">
          <li><strong>Article 99</strong> — Ramadan 6h/day for Muslim workers</li>
          <li><strong>Article 104</strong> — daily max hours including OT (11h)</li>
          <li><strong>Article 105</strong> — mandatory rest period after 5h continuous</li>
          <li><strong>Articles 107-108</strong> — OT premium (1.5x / 2x for holidays)</li>
        </ul>
      </section>
    </div>
  );
}
